import React from 'react';
import { Card } from '../ui/card';

export function ProgressBarCard({
  currentStepIndex,
  totalSteps,
  progressPercentage,
  statusList
}) {
  return (
    <Card className='p-5 bg-white shadow-md'>
      <div className='mb-1 flex items-center justify-between'>
        <div className=' font-medium'>
          Application Progress ({currentStepIndex + 1}/{totalSteps})
        </div>
        <div className=' text-gray-500'>
          {Math.round(progressPercentage)}%
        </div>
      </div>
      <div className='w-full bg-gray-100 rounded-full h-2.5 mb-4'>
        <div
          className='bg-[#FF5533] h-2.5 rounded-full'
          style={{ width: `${progressPercentage}%` }}
        ></div>
      </div>

      <div className='flex items-center justify-between text-sm text-gray-500'>
        {statusList.map((step, index) => (
          <React.Fragment key={index}>
            <div className='flex flex-col items-center'>
              <div
                className={`w-4 h-4 rounded-full mb-1 ${index <= currentStepIndex ? 'bg-[#FF5533]' : 'bg-gray-300'
                  }`}
              ></div>
              <span>{step.label}</span>
            </div>
            {index < statusList.length - 1 && (
              <div className='flex-1 h-px bg-gray-200 mx-1'></div>
            )}
          </React.Fragment>
        ))}
      </div>
    </Card>
  );
}
